var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "修改展示时间",
        visible: _vm.dialogVisible,
        width: "450px",
        "close-on-click-modal": false,
        "show-close": true,
        center: "",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "time-modify-content" }, [
        _c("div", { staticClass: "warning-icon" }, [
          _c("i", { staticClass: "el-icon-warning-outline" }),
        ]),
        _c("div", { staticClass: "warning-message" }, [
          _vm._v(" 展示时间已过，请修改后上架 "),
        ]),
        _c(
          "div",
          { staticClass: "time-picker-container" },
          [
            _c("div", { staticClass: "time-label" }, [_vm._v("展示时间")]),
            _c("el-date-picker", {
              staticStyle: { width: "100%" },
              attrs: {
                type: "datetimerange",
                "range-separator": "—",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                format: "yyyy-MM-dd HH:mm:ss",
                "value-format": "yyyy-MM-dd HH:mm:ss",
                "picker-options": _vm.pickerOptions,
                "default-time": ["00:00:00", "23:59:59"],
              },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }